import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Alert, Grid, Row, Col } from 'react-bootstrap'
import Loader from 'react-loader'
import moment from 'moment'
import HtmlTitle from '../../html-title'
import Form from '../form'
import * as actions from '../../../actions/recurring-pickups'
import * as terminalActions from '../../../actions/terminals'
import * as ownerActions from '../../../actions/owner'
import * as driverActions from '../../../actions/user'
import auth from '../../../auth'
import { getClosestInstanceOfWeekDay } from '../../../utils/date'
import { STOP_TYPE, validate, checkIfMerchantRoute } from '../../../utils/recurring-pickups'
import { OPERATIONS_ADMIN, OPERATIONS_COORDINATOR } from '../../../utils/role'

const initialPickups = () => []

class OneTimePickupCreateHandler extends Component {
    constructor(...args) {
        super(...args)
        this.state = {
            initialModel: {
                name: '',
                pickups: initialPickups(),
                date: moment(),
                courierId: '-1',
                driverId: '-1',
                remuneration: '',
                currency: 'SEK',
                maxPallets: '',
                vehicleType: '',
                vehicleUtilisationFactor: 100,
                linehaulCost: null,
                requiredPallets: null,
            },
            isReadOnly: false,
        }
    }

    componentDidMount() {
        const hasAuth = auth.hasAnyRole(OPERATIONS_ADMIN, OPERATIONS_COORDINATOR)
        if (!hasAuth) {
            this.props.router.push('/admin')
            return
        }

        this.props.actions.fetchRecurringPickup(this.props.params.id)
        this.props.ownerActions.fetchOwnersWebapi()
        this.props.terminalActions.fetchTerminalsWebapi()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pickup.courierId !== this.state.initialModel.courierId && nextProps.pickup.courierId) {
            this.props.driverActions.getCourierUsers(nextProps.pickup.courierId)
        }
        this.setState((state) => ({
            initialModel: {
                ...state.initialModel,
                name: nextProps.pickup.name,
                dayOfWeek: nextProps.pickup.dayOfWeek != null ? nextProps.pickup.dayOfWeek.toUpperCase() : '-1',
                date: getClosestInstanceOfWeekDay(nextProps.pickup.dayOfWeek),
                isOneTimeRoute: true,
                courierId: nextProps.pickup.courierId,
                driverId: nextProps.pickup.driverId != null ? nextProps.pickup.driverId : '-1',
                maxPallets: nextProps.pickup.maxPallets,
                vehicleType: nextProps.pickup.vehicleType,
                vehicleUtilisationFactor: parseInt(nextProps.pickup.vehicleUtilisationFactor * 100),
                linehaulCost: nextProps.pickup.linehaulCost,
                remuneration: nextProps.pickup.remuneration,
                currency: nextProps.pickup.currency,
                pickups:
                    nextProps.pickup.stops != null
                        ? nextProps.pickup.stops.map((stop, sortOrder) => {
                              switch (stop.type) {
                                  case STOP_TYPE.MERCHANT:
                                      return {
                                          ...stop,
                                          id: sortOrder,
                                          merchantScheduleId: stop.collectionPointMerchantScheduleId,
                                      }
                                  default:
                                      return {
                                          ...stop,
                                          id: sortOrder,
                                      }
                              }
                          })
                        : [],
            },
            isReadOnly: state.isReadOnly || Boolean(nextProps.pickup.instaboxId),
        }))
    }

    onCourierChange = (courierId) => {
        this.props.driverActions.getCourierUsers(courierId)
    }

    onSubmit = (form, e) => {
        e.preventDefault()

        const stops = form.pickups.map((pickup, sortOrder) => {
            switch (pickup.type) {
                case STOP_TYPE.MERCHANT:
                    return {
                        type: pickup.type,
                        merchantScheduleId: pickup.merchantScheduleId,
                        returns: pickup.returns,
                        pickup: pickup.pickup,
                        startTime: pickup.startTime,
                        endTime: pickup.endTime,
                        sortOrder,
                    }
                case STOP_TYPE.TERMINAL:
                    return {
                        type: pickup.type,
                        terminalId: pickup.terminalId,
                        startTime: pickup.startTime,
                        endTime: pickup.endTime,
                        sortOrder,
                    }
                case STOP_TYPE.REST:
                    return {
                        type: pickup.type,
                        startTime: pickup.startTime,
                        endTime: pickup.endTime,
                        sortOrder,
                    }
                default:
                    return { ...pickup, sortOrder }
            }
        })
        checkIfMerchantRoute(form.pickups) ? null : form.linehaulCost = null
        const model = {
            name: form.name,
            date: moment(form.date).format('YYYY-MM-DD'),
            courierId: form.courierId,
            driverId: form.driverId === '-1' ? null : form.driverId,
            remuneration: form.remuneration, // Remuneration value is in cents
            currency: form.currency,
            pallets: form.maxPallets,
            vehicleType: form.vehicleType,
            vehicleUtilisationFactor: form.vehicleUtilisationFactor / 100,
            linehaulCost: form.linehaulCost,
            stops,
        }
        this.props.actions.createOneTimeRoute(this.props.params.id, model, this.props.router)
    }

    render() {
        const { fetchRecurringPickupCollectionPoints, fetchRecurringPickupCollectionPointSchedules } = this.props.actions
        const { isReadOnly } = this.state
        return (
            <div>
                <HtmlTitle title="One-time route" />

                <Loader color="#bfbfbf" loaded={this.props.loaded}>
                    <Grid fluid>
                        <Row>
                            <Col md={8} mdOffset={2}>
                                {isReadOnly ? (
                                    <Alert bsStyle="danger">
                                        <span>Cannot create one time routes from routes managed through Orderadmin</span>
                                    </Alert>
                                ) : (
                                    <h1>Create one-time route</h1>
                                )}
                            </Col>
                        </Row>
                        {!isReadOnly && (
                            <Form
                                onSubmit={this.onSubmit}
                                onCourierChange={this.onCourierChange}
                                initialModel={this.state.initialModel}
                                owners={this.props.owners}
                                drivers={this.props.drivers}
                                terminals={this.props.terminals}
                                locations={this.props.locations}
                                multipleLocationsOptions={this.props.multipleLocationsOptions}
                                validate={validate}
                                fetchRecurringPickupCollectionPoints={fetchRecurringPickupCollectionPoints}
                                fetchRecurringPickupCollectionPointSchedules={fetchRecurringPickupCollectionPointSchedules}
                                initialPickups={initialPickups}
                                showSubmitButtonCreate
                                checkIfMerchantRoute={checkIfMerchantRoute}
                            />
                        )}
                    </Grid>
                </Loader>
            </div>
        )
    }
}
OneTimePickupCreateHandler.propTypes = {
    router: PropTypes.object,
    params: PropTypes.object,
    actions: PropTypes.object,
    ownerActions: PropTypes.object,
    terminalActions: PropTypes.object,
    driverActions: PropTypes.object,
    pickup: PropTypes.object,
    loaded: PropTypes.bool,
    owners: PropTypes.array,
    drivers: PropTypes.array,
    terminals: PropTypes.array,
    locations: PropTypes.array,
    multipleLocationsOptions: PropTypes.array,
}

const mapStateToProps = ({ owners, terminals, users, recurringPickups: { loaded, locations, selected: pickup, multipleLocationsOptions } }) => ({
    loaded,
    pickup,
    owners: owners.data,
    terminals: terminals.terminals,
    drivers: users.data,
    locations,
    multipleLocationsOptions,
})

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    driverActions: bindActionCreators(driverActions, dispatch),
    terminalActions: bindActionCreators(terminalActions, dispatch),
    ownerActions: bindActionCreators(ownerActions, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(OneTimePickupCreateHandler)
